import { useState, useEffect } from 'react';
import api from '../core/api';

export interface PlanData {
    accountStatus: string; // 'trial_active' | 'trial_expired' | 'pro_active' | 'basic_active'
    hasProFeatures: boolean;
    isTrialExpired: boolean;
    planLabel: string;
    isTrial: boolean;
    daysRemaining: number;
    trialEndsAt: string | null;
    contactsUsed: number;
    contactsLimit: number;
    // legacy
    plan: string;
    isPro: boolean;
}

export function usePlan(): PlanData | null {
    const [data, setData] = useState<PlanData | null>(null);

    useEffect(() => {
        api.get('/organization/usage')
            .then(res => setData(res.data))
            .catch(() => {});
    }, []);

    return data;
}
